module.exports = __webpack_public_path__ + "img/figuur.a.d32ab518.svg";